import styled from '@emotion/styled'
import FlexisName from '@/assets/flexis-name.svg'
import FlexisLogo from '@/assets/flexis-logo.svg'
import { Stack } from '@mui/material'

const LogoSVG = styled('img', {
  shouldForwardProp: prop => prop !== 'logoHeight'
})<{ logoHeight?: number }>(({ logoHeight }) => ({
  height: logoHeight ? `${logoHeight}px` : '13px',
  width: 'auto'
}))

export default function FlexisNameLogo() {
  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      <LogoSVG src={FlexisLogo} logoHeight={24} />
      <LogoSVG src={FlexisName} />
    </Stack>
  )
}
